// Shared error code for plan-access gates across modules (Plannings, Tareas
// asignadas). Mirrors the backend's PricingErrorCodes module -- neutral home
// so it isn't duplicated per module.
export const FEATURE_NOT_IN_PLAN = 'feature-not-in-plan';
